export const environment = {
  production: true,
  portalURL: '/api-portal',
  wsURL: '/api-websocket',
  contractURL:'/api-contract',
  docStoreURL: '/api-docstore',
};
